import { Loader2 } from 'lucide-react';

import { EmptyTaskState } from './EmptyTaskState';
import { TaskCard } from './TaskCard';

import type { TaskDetail, TaskTabType } from '@/types';

type EmptyReason = 'noTasks' | 'search' | 'filter';

interface TaskListProps {
  tasks: TaskDetail[];
  tab: TaskTabType;
  isLoading: boolean;
  operatingTaskId: string | null;
  hasInProgressTask?: boolean | undefined;
  emptyReason?: EmptyReason | undefined;
  onAccept?: ((task: TaskDetail) => void) | undefined;
  onStart?: ((task: TaskDetail) => void) | undefined;
  onCancel?: ((task: TaskDetail) => void) | undefined;
  onView?: ((task: TaskDetail) => void) | undefined;
  onNavigateToTab?: ((tab: TaskTabType) => void) | undefined;
}

export function TaskList({
  tasks,
  tab,
  isLoading,
  operatingTaskId,
  hasInProgressTask,
  emptyReason,
  onAccept,
  onStart,
  onCancel,
  onView,
  onNavigateToTab,
}: TaskListProps) {
  if (isLoading && tasks.length === 0) {
    return (
      <div className="flex items-center justify-center py-16">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (tasks.length === 0) {
    return (
      <EmptyTaskState
        tab={tab}
        hasInProgressTask={hasInProgressTask}
        emptyReason={emptyReason}
        onNavigateToTab={onNavigateToTab}
      />
    );
  }

  return (
    <div className="space-y-4">
      {tasks.map((task) => (
        <TaskCard
          key={task.TaskId}
          task={task}
          tab={tab}
          isOperating={operatingTaskId === task.TaskId}
          onAccept={
            onAccept
              ? () => {
                  onAccept(task);
                }
              : undefined
          }
          onStart={
            onStart
              ? () => {
                  onStart(task);
                }
              : undefined
          }
          onCancel={
            onCancel
              ? () => {
                  onCancel(task);
                }
              : undefined
          }
          onView={
            onView
              ? () => {
                  onView(task);
                }
              : undefined
          }
        />
      ))}
    </div>
  );
}
